import { Typography } from '@mui/material';
import { get } from 'lodash';

export const DefaultCell = ({ row, field }) => {
    return <Typography>{get(row, field)}</Typography>;
};
